export const CARD_HEADER_HEIGHT = 84;
export const HEADING_VARIANT = "subtitle2";
export const SUBHEADING_VARIANT = "caption";
export const HEADER_PADDING = "20px";
